export default __webpack_public_path__ + "static/adults-product-2-037a76313d1a4090527c27d89b286c0d.png";